module.exports = {"530921101":"凤山镇","530921102":"鲁史镇","530921103":"小湾镇","530921104":"营盘镇","530921105":"三岔河镇","530921106":"勐佑镇","530921107":"雪山镇","530921108":"洛党镇","530921201":"诗礼乡","530921202":"新华乡","530921204":"大寺乡","530921206":"腰街乡","530921207":"郭大寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530921.json
// module id = 2416
// module chunks = 0